import styled from 'styled-components'

const Wrapper = styled.div`
  main {
    min-height: calc(100vh - 240px);
    @media (orientation: portrait) {
      min-height: calc(100vh - 168px);
    }
  }
`

export { Wrapper }
